import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';

import { SearchResultsRowComponent } from 'shared/search/search-results/search-results-row/search-results-row.component';


@Component({
  moduleId: module.id,
  selector: 'import-manager-search-results-row',
  templateUrl: 'import-manager-search-results-row.component.html',
  styleUrls: ['import-manager-search-results-row.component.scss']
})
export class ImportManagerSearchResultsRowComponent extends SearchResultsRowComponent {

  @Input() declare timezone: any;

  @Output() viewReportClick: EventEmitter<any> = new EventEmitter();

  constructor(
    protected router: Router,
  ) {
    super();
  }

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/
   get isItems(): boolean {
     return _.get(this.row, 'import_type') === 'ITEMS';
   }

   get isFitments(): boolean {
     return _.get(this.row, 'import_type') === 'APPS';
   }

  get isCustomFields(): boolean {
    return _.get(this.row, 'import_type') === 'CUSTOM FIELDS';
  }

   get isLinkDisabled(): boolean {
     return !this.row.download.completed ||
      _.isNil(this.row.parts_import_id) ||
      this.row.report.status === 3;
   }

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onFilenameLinkClick($event: any) {
    if (!this.isLinkDisabled) {
      if (this.row.import_type.indexOf('ITEMS') >= 0) {
        this.router.navigate([`/import-manager/import-review-pies/${this.row.parts_import_id}`], { queryParams: {csm: 1}});
      } else if (this.row.import_type.indexOf('APPS') >= 0) {
        this.router.navigate([`/import-manager/import-review-aces/${this.row.parts_import_id}`], { queryParams: {csm: 1}});
      } else if (this.row.import_type.indexOf('CUSTOM FIELDS') >= 0) {
        this.router.navigate([`/import-manager/import-review-custom-fields/${this.row.parts_import_id}`], { queryParams: {csm: 1}});
      }
    }
  }

  onViewReportClick() {
    this.viewReportClick.emit(this.row);
  }

  /*******************************************
   * COMPONENT PRIVATE METHODS
   *******************************************/

  private getText(columnName: any): string {
    switch (columnName) {
      case 'app_count':
      case 'item_count':
        if (!this.row.download.completed) {
          return 'Counting';
        } else if (
          (columnName === 'app_count' && this.isItems) ||
          (columnName === 'item_count' && this.isFitments)
        ) {
          return '—';
        }
        return null;
      case 'report':
        if (!this.row.report.completed) {
          return 'Compiling report';
        }
        return 'View report';
      default:
        return null;
    }
  }
}
